var map = {
	"./abkhazia.svg": "ae54",
	"./afghanistan.svg": "97f0",
	"./aland-islands.svg": "42f4",
	"./albania.svg": "ca24",
	"./algeria.svg": "af4a",
	"./american-samoa.svg": "f674",
	"./andorra.svg": "ede0",
	"./angola.svg": "9555",
	"./anguilla.svg": "5ed0",
	"./antigua-and-barbuda.svg": "4165",
	"./argentina.svg": "4a9c",
	"./armenia.svg": "1788",
	"./aruba.svg": "8d27",
	"./australia.svg": "cd37",
	"./austria.svg": "7f57",
	"./azerbaijan.svg": "33c5",
	"./azores-islands.svg": "1c08",
	"./bahamas.svg": "8954",
	"./bahrain.svg": "d61a",
	"./balearic-islands.svg": "b170",
	"./bangladesh.svg": "bf5f",
	"./barbados.svg": "b9fb",
	"./basque-country.svg": "1d12",
	"./belarus.svg": "011e",
	"./belgium.svg": "6b81",
	"./belize.svg": "7aec",
	"./benin.svg": "6a89",
	"./bermuda.svg": "7e7e",
	"./bhutan.svg": "b5f9",
	"./bolivia.svg": "5e75",
	"./bonaire.svg": "24b4",
	"./bosnia-and-herzegovina.svg": "9efd",
	"./botswana.svg": "6ad1",
	"./brazil.svg": "5a54",
	"./british-columbia.svg": "c06d",
	"./british-indian-ocean-territory.svg": "fdac",
	"./british-virgin-islands.svg": "6940",
	"./brunei.svg": "0e02",
	"./bulgaria.svg": "7506",
	"./burkina-faso.svg": "9b45",
	"./burundi.svg": "2bf0",
	"./cambodia.svg": "aaf9",
	"./cameroon.svg": "fabb",
	"./canada.svg": "732a",
	"./canary-islands.svg": "b567",
	"./cape-verde.svg": "b3bc",
	"./cayman-islands.svg": "5196",
	"./central-african-republic.svg": "a4f8",
	"./ceuta.svg": "f1e2",
	"./chad.svg": "59d4",
	"./chile.svg": "8f4b",
	"./china.svg": "84bd",
	"./christmas-island.svg": "7080",
	"./cocos-island.svg": "a1ec",
	"./colombia.svg": "3315",
	"./comoros.svg": "272f",
	"./cook-islands.svg": "d9a4",
	"./corsica.svg": "7b31",
	"./costa-rica.svg": "7f42",
	"./croatia.svg": "c08e",
	"./cuba.svg": "a4cf",
	"./curacao.svg": "6b2f",
	"./cyprus.svg": "f605",
	"./czech-republic.svg": "26ec",
	"./democratic-republic-of-congo.svg": "c9ff",
	"./denmark.svg": "80d0",
	"./djibouti.svg": "d103",
	"./dominica.svg": "8b17",
	"./dominican-republic.svg": "eea3",
	"./east-timor.svg": "dab0",
	"./ecuador.svg": "503a",
	"./egypt.svg": "045b",
	"./el-salvador.svg": "3358",
	"./england.svg": "94bd",
	"./equatorial-guinea.svg": "2dde",
	"./eritrea.svg": "407d",
	"./estonia.svg": "fc0d",
	"./ethiopia.svg": "9c03",
	"./european-union.svg": "b39a",
	"./falkland-islands.svg": "91f1",
	"./faroe-islands.svg": "5a16",
	"./fiji.svg": "1850",
	"./finland.svg": "1168",
	"./france.svg": "8f21",
	"./french-polynesia.svg": "dede",
	"./gabon.svg": "e101",
	"./galapagos-islands.svg": "feb1",
	"./gambia.svg": "c238",
	"./georgia.svg": "1777",
	"./germany.svg": "c1f7",
	"./ghana.svg": "986e",
	"./gibraltar.svg": "eb1a",
	"./greece.svg": "87b4",
	"./greenland.svg": "f375",
	"./grenada.svg": "a887",
	"./guam.svg": "1e8b",
	"./guatemala.svg": "19f2",
	"./guernsey.svg": "1cf3",
	"./guinea-bissau.svg": "9b11",
	"./guinea.svg": "15bb",
	"./haiti.svg": "3ec5",
	"./hawaii.svg": "d406",
	"./honduras.svg": "b768",
	"./hong-kong.svg": "c91c",
	"./hungary.svg": "665c",
	"./iceland.svg": "18c6",
	"./india.svg": "1efb",
	"./indonesia.svg": "2e50",
	"./iran.svg": "dddc",
	"./iraq.svg": "3600",
	"./ireland.svg": "a9b9",
	"./isle-of-man.svg": "0dd2",
	"./israel.svg": "1965",
	"./italy.svg": "21b8",
	"./ivory-coast.svg": "36f5",
	"./jamaica.svg": "9339",
	"./japan.svg": "d0d2",
	"./jersey.svg": "7a90",
	"./jordan.svg": "088b",
	"./kazakhstan.svg": "c4b0",
	"./kenya.svg": "9c92",
	"./kosovo.svg": "8d96",
	"./kuwait.svg": "10a4",
	"./kyrgyzstan.svg": "2c5e",
	"./laos.svg": "1c59",
	"./latvia.svg": "d8af",
	"./lebanon.svg": "4206",
	"./lesotho.svg": "7cad",
	"./liberia.svg": "5593",
	"./libya.svg": "4d13",
	"./liechtenstein.svg": "e114",
	"./lithuania.svg": "b76a",
	"./luxembourg.svg": "ebd0",
	"./macao.svg": "4565",
	"./madagascar.svg": "dbad",
	"./madeira.svg": "8724",
	"./malawi.svg": "bba6",
	"./malaysia.svg": "7582",
	"./maldives.svg": "c7d7",
	"./mali.svg": "0f10",
	"./malta.svg": "b3a8",
	"./marshall-island.svg": "f2ae",
	"./martinique.svg": "b78d",
	"./mauritania.svg": "f4d1",
	"./mauritius.svg": "b4e1",
	"./melilla.svg": "b01d",
	"./mexico.svg": "7e70",
	"./micronesia.svg": "0939",
	"./moldova.svg": "2299",
	"./monaco.svg": "5473",
	"./mongolia.svg": "f446",
	"./montenegro.svg": "6165",
	"./montserrat.svg": "ecd6",
	"./morocco.svg": "5d99",
	"./mozambique.svg": "6680",
	"./myanmar.svg": "b142",
	"./namibia.svg": "140c",
	"./nauru.svg": "9bd9",
	"./nepal.svg": "0c74",
	"./netherlands.svg": "d3b1",
	"./new-zealand.svg": "f5c7",
	"./nicaragua.svg": "c791",
	"./niger.svg": "7319",
	"./nigeria.svg": "dab3",
	"./niue.svg": "ae41",
	"./norfolk-island.svg": "479c",
	"./north-korea.svg": "3be3",
	"./northen-cyprus.svg": "5de0",
	"./northern-marianas-islands.svg": "b277",
	"./norway.svg": "58bb",
	"./oman.svg": "c121",
	"./orkney-islands.svg": "c844",
	"./ossetia.svg": "d1be",
	"./otan.svg": "37ad",
	"./pakistan.svg": "e898",
	"./palau.svg": "0ae5",
	"./palestine.svg": "24b6",
	"./panama.svg": "afa4",
	"./papua-new-guinea.svg": "d5eb",
	"./paraguay.svg": "1046",
	"./peru.svg": "5fe0",
	"./philippines.svg": "913e",
	"./pitcairn-islands.svg": "c060",
	"./poland.svg": "6718",
	"./portugal.svg": "6d0b",
	"./puerto-rico.svg": "0fd9",
	"./qatar.svg": "8e13",
	"./rapa-nui.svg": "7228",
	"./republic-of-macedonia.svg": "6235",
	"./republic-of-the-congo.svg": "3f2e",
	"./romania.svg": "4afb",
	"./russia.svg": "a6e4",
	"./rwanda.svg": "0264",
	"./saba-island.svg": "c949",
	"./sahrawi-arab-democratic-republic.svg": "945d",
	"./saint-kitts-and-nevis.svg": "bd1f",
	"./samoa.svg": "15cd",
	"./san-marino.svg": "93d7",
	"./sao-tome-and-principe.svg": "24c8",
	"./sardinia.svg": "49f1",
	"./saudi-arabia.svg": "b0419",
	"./scotland.svg": "e0e0",
	"./senegal.svg": "a12a",
	"./serbia.svg": "7131",
	"./seychelles.svg": "a1c4",
	"./sicily.svg": "1399",
	"./sierra-leone.svg": "37d4",
	"./singapore.svg": "9219",
	"./sint-eustatius.svg": "df3f",
	"./sint-maarten.svg": "c1f1",
	"./slovakia.svg": "394b",
	"./slovenia.svg": "c36c",
	"./solomon-islands.svg": "4631",
	"./somalia.svg": "be87",
	"./somaliland.svg": "23fe",
	"./south-africa.svg": "dcd2",
	"./south-korea.svg": "3f5b",
	"./south-sudan.svg": "983d",
	"./spain.svg": "c28b",
	"./sri-lanka.svg": "fede",
	"./st-barts.svg": "09c8",
	"./st-lucia.svg": "8354",
	"./st-vincent-and-the-grenadines.svg": "afee",
	"./sudan.svg": "8631",
	"./suriname.svg": "7420",
	"./sweden.svg": "419a",
	"./switzerland.svg": "eefe",
	"./syria.svg": "709f",
	"./taiwan.svg": "5e28",
	"./tajikistan.svg": "b3f3",
	"./tanzania.svg": "2c69",
	"./thailand.svg": "97ca",
	"./tibet.svg": "aaba",
	"./togo.svg": "306d",
	"./tokelau.svg": "4f71",
	"./tonga.svg": "964a",
	"./transnistria.svg": "9732",
	"./trinidad-and-tobago.svg": "c476",
	"./tubalu.svg": "03bd",
	"./tunisia.svg": "65a2",
	"./turkey.svg": "4320",
	"./turkmenistan.svg": "2b2c",
	"./turks-and-caicos.svg": "eafb",
	"./uganda.svg": "332f",
	"./ukraine.svg": "d824",
	"./united-arab-emirates.svg": "d203",
	"./united-kingdom.svg": "0699",
	"./united-nations.svg": "ce28",
	"./united-states-of-america.svg": "f439",
	"./uruguay.svg": "f122",
	"./uzbekistn.svg": "7f80",
	"./vanuatu.svg": "6b0c",
	"./vatican-city.svg": "8b21",
	"./venezuela.svg": "2297",
	"./vietnam.svg": "41cc",
	"./virgin-islands.svg": "dcf7",
	"./wales.svg": "1e4b",
	"./yemen.svg": "50eb",
	"./zambia.svg": "5e05",
	"./zimbabwe.svg": "69d5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1946";